/**
 * Identity module entry point.
 *
 * In this repo (`surface-mesh-hierarchical`), the active factory is
 * HierarchicalIdentityFactory. The global repo exports the same name from
 * this path but points to GlobalIdentityFactory. Application code imports
 * from `@/identity` and remains agnostic.
 */

export type {
  Bytes,
  Context,
  ContextHash,
  IdentityFactory,
  LinkageProof,
  PublicKey,
  Signature,
  SignerIdentity,
} from './SignerIdentity';

export { HierarchicalIdentityFactory as ActiveIdentityFactory } from './hierarchical';

/** The identity model in use by this build. Useful for diagnostics. */
export const IDENTITY_MODEL = 'hierarchical' as const;
